import React from 'react'
import { Col, Row } from 'react-bootstrap'
import ImgTopCard from '../General/ImgTopCard'
import mejoresCarrerasBg from '../../assets/carreras.jpg'
import aptitudBg from '../../assets/aptitud.jpg'
import vocacioalBg from '../../assets/vocacional.jpg'
import listaUniBg from '../../assets/listaUniversidades.jpg'

const ProyectosList = () =>{
    return (
        <>
        <div className = "container mt-5">
            <div className = "text-center">
                <h1>Escolares</h1>
                <p>Proyectos relacionados con lo académico</p>
            </div>
            <Row  xs={1} md={4}>
                <Col>
                    <ImgTopCard img = {mejoresCarrerasBg} title = "Mejores carreras en México" p = "Una lista con las carreras mejor pagadas en México" link = "/mejorescarreras" linkTitle = "Ver"/>
                </Col>
                <Col>
                    <ImgTopCard img = {vocacioalBg} title = "Test de vocacional" p = "Un test que vocacional sobre que quieres estudiar" link = "/test-vocacional" linkTitle = "Ver"/>
                </Col>
                <Col>
                    <ImgTopCard img = {aptitudBg} title = "Test de aptitud" p = "Un test que te orienta sobre que quieres estudiar" link = "/test-aptitud" linkTitle = "Ver"/>
                </Col>
                <Col>
                    <ImgTopCard img = {listaUniBg} title = "Lista de Universidades Uruapan" p = "Información de las mejores universidades de uruapan" link = "/lista-universidades" linkTitle = "Ver"/>
                </Col>
            </Row>
            
            
            
        </div>
        </>
    )
}

export default ProyectosList